import gsap from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

$(window).on("load", function () {

  var secCount = $('.js-sec-count').length +1;
  let sectionItem
  let navItem

  // for (let i = 1; i < 6; i++) {
  for (let i = 1; i < secCount; i++) {
    navItem = '.js-current-nav' + i
    sectionItem = '.js-current-sec' + i
    console.log(secCount)
    ScrollTrigger.create({
      trigger: sectionItem,
      start: 'top center',
      end: 'bottom center',
      toggleClass: {
        targets: navItem,
        className: 'is-current',
      },
      // once: true,
      // markers: true,
    });
  }
});
